var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowToIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.79,13.38c0,.55-.48,1.03-1.06,1.03s-1.06-.47-1.06-1.03,.47-1.04,1.06-1.04,1.06,.47,1.06,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.19,7.41c0,1.4-.9,2.06-1.66,2.6-.64,.46-1.13,.85-1.13,1.51v.29h-1.45v-.29c0-1.19,.73-1.8,1.42-2.34,.59-.47,1.12-.91,1.12-1.67,0-.89-.55-1.47-1.46-1.47s-1.57,.69-1.57,1.7h-1.66c0-1.87,1.37-3.18,3.26-3.18s3.12,1.12,3.12,2.86Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,18.83c-2.3,0-4.18-1.87-4.18-4.18h1c0,1.75,1.42,3.18,3.18,3.18s3.18-1.42,3.18-3.18h1c0,2.3-1.87,4.18-4.18,4.18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToIcon);
export default __webpack_public_path__ + "static/media/How-to-Icon.f2fc8856cc9404d471b04c1186726b04.svg";
export { ForwardRef as ReactComponent };